export default __webpack_public_path__ + "static/media/10_placing_order.8371224d.png";